import { c as _c } from "react-compiler-runtime";
import { useRef } from "react";
import { triggerVibration } from "@/core/device";
export function useCaptureFeedback() {
  const $ = _c(3);
  const audioContextRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const ensureAudioContext = () => {
      if (audioContextRef.current) {
        return audioContextRef.current;
      }
      try {
        const context = new AudioContext();
        audioContextRef.current = context;
        return context;
      } catch {
        return null;
      }
    };
    t0 = (frequency, durationMs, t1) => {
      const gain = t1 === undefined ? 0.05 : t1;
      const context_0 = ensureAudioContext();
      if (!context_0) {
        return;
      }
      const oscillator = context_0.createOscillator();
      const gainNode = context_0.createGain();
      oscillator.type = "sine";
      oscillator.frequency.value = frequency;
      gainNode.gain.value = gain;
      oscillator.connect(gainNode);
      gainNode.connect(context_0.destination);
      oscillator.start();
      oscillator.stop(context_0.currentTime + durationMs / 1000);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const playTone = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      playTone(520, 120, 0.06);
      triggerVibration(20);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const triggerBeep = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    const triggerShutter = () => {
      playTone(880, 80, 0.05);
      playTone(640, 120, 0.04);
      triggerVibration([30, 40, 30]);
    };
    t2 = {
      triggerBeep,
      triggerShutter
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}